import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import messages from '../../locale/messages';

/**
 * Simple confirmation modal for admin (and other) destructive remove actions.
 * Use with controlled `show`; call `onCancel` when closing without confirming.
 */
function ConfirmRemoveDialog({ show, itemName, onConfirm, onCancel, intl }) {
  const { formatMessage } = intl;
  const displayName =
    itemName != null && String(itemName).trim() !== ''
      ? String(itemName)
      : formatMessage(messages.adminConfirmRemoveUnnamedItem);

  return (
    <Modal show={show} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>{formatMessage(messages.adminConfirmRemoveTitle)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{formatMessage(messages.adminConfirmRemoveItem, { itemName: displayName })}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" onClick={onCancel}>
          {formatMessage(messages.cancel)}
        </Button>
        <Button type="button" bsStyle="primary" onClick={onConfirm}>
          {formatMessage(messages.yesLabel)}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default injectIntl(ConfirmRemoveDialog);
